// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  // apiBaseUrl: 'https://localhost:44389/api',
   apiBaseUrl: 'https://test-cmpapi.aspcore.net/api',
  // apiBaseUrl: 'https://dev-cmpapi.aspcore.net/api',
  googleClientId: '762723070255-vqbqdeo7sh4ocd3g7vghb5p4fl4avm1a.apps.googleusercontent.com',
  paging: {
    defaultPageSize: 10,
    lengthMenu: [10, 15, 25, 50, 100]
  },
  dateTimeFormat: {
    date: 'yyyy-MM-dd',
    dateTime: 'yyyy-MM-dd h:mm:ss a',
    dateTime_minutes: 'yyyy-MM-dd h:mm a'
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
  // import 'zone.js/dist/zone-error';  // Included with Angular CLI.

